(function () {
  function wrapRevealChars(root) {
    const chars = [];
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) {
      if (!node.textContent) continue;
      textNodes.push(node);
    }
    textNodes.forEach((textNode) => {
      const text = textNode.textContent;
      const frag = document.createDocumentFragment();
      for (const char of text) {
        if (/\s/.test(char)) {
          frag.appendChild(document.createTextNode(char));
        } else {
          const letter = document.createElement("span");
          letter.className = "sa-mw-section__char";
          letter.textContent = char;
          frag.appendChild(letter);
          chars.push(letter);
        }
      }
      textNode.parentNode.replaceChild(frag, textNode);
    });
    return chars;
  }

  function initReveal(section, reduceMotion) {
    const roots = section.querySelectorAll("[data-sa-reveal-root]");
    if (!roots.length) return;
    const speed = Math.max(1, Number(section.dataset.saSpeed) || 27);
    const chars = [];
    roots.forEach((root) => {
      chars.push(...wrapRevealChars(root));
    });
    if (!chars.length) return;

    if (reduceMotion) {
      chars.forEach((el) => el.classList.add("sa-mw-section__char--lit"));
      return;
    }

    let visible = 0;
    let start = 0;
    let frameId = null;
    function step(time) {
      if (!start) start = time;
      const target = Math.min(chars.length, Math.floor(((time - start) * speed) / 1000));
      for (; visible < target; visible++) {
        chars[visible].classList.add("sa-mw-section__char--lit");
      }
      if (visible < chars.length) frameId = requestAnimationFrame(step);
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        frameId = requestAnimationFrame(step);
      },
      { threshold: 0.2 }
    );
    observer.observe(section);
    section._saMwRevealCleanup = () => {
      observer.disconnect();
      if (frameId) cancelAnimationFrame(frameId);
    };
  }

  function initSmoke(section, reduceMotion) {
    const canvas = section.querySelector(".sa-mw-section__canvas");
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let width = 0;
    let height = 0;
    let frameId = null;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);

    function resize() {
      const rect = canvas.getBoundingClientRect();
      width = rect.width;
      height = rect.height;
      canvas.width = Math.round(width * dpr);
      canvas.height = Math.round(height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function gauss(x, mid, spread) {
      return Math.exp(-Math.pow((x - mid) / spread, 2));
    }

    function draw(time) {
      if (!width || !height) return;
      ctx.clearRect(0, 0, width, height);
      const t = reduceMotion ? 0 : time * 0.001;

      ctx.save();
      ctx.globalCompositeOperation = "screen";
      const mistCount = 29;
      const mistDrift = width * 0.012;
      for (let i = 0; i < mistCount; i++) {
        const seed = i * 12.987;
        const u = (i + 0.5) / mistCount;
        const drift = Math.sin(t * 0.16 + seed) * mistDrift;
        const x = width * u + drift;
        const y = height * (0.67 + 0.2 * Math.sin(seed * 0.77 + t * 0.12));
        const radius = Math.max(width, height) * (0.07 + (i % 4) * 0.016);
        const fog = ctx.createRadialGradient(x, y, 0, x, y, radius);
        const alpha = 0.05 + 0.02 * (1 + Math.sin(t * 0.5 + seed));
        fog.addColorStop(0, "rgba(255,180,0," + alpha + ")");
        fog.addColorStop(0.5, "rgba(208,100,0," + alpha * 0.35 + ")");
        fog.addColorStop(1, "rgba(182,73,0,0)");
        ctx.fillStyle = fog;
        ctx.fillRect(x - radius, y - radius, radius * 2, radius * 2);
      }
      ctx.restore();

      const unit = height / 175;
      const stepX = width < 600 ? 4 : 4.1;
      const stepY = Math.max(3.4, 4.1 * Math.min(1.35, unit));
      const dotW = Math.max(1.15, 1.15 * Math.min(1.4, unit));
      const dotH = Math.max(2.1, 2.1 * Math.min(1.4, unit));
      for (let x = 0; x < width; x += stepX) {
        const u = x / width;
        const shape =
          (28 +
            120 * gauss(u, -0.02, 0.13) +
            49 * gauss(u, 0.235, 0.12) +
            37 * gauss(u, 0.59, 0.18) +
            132 * gauss(u, 1.04, 0.17)) *
          unit;
        const ripple =
          (6 * Math.sin(u * 28 + t * 1.45) +
            5 * Math.sin(u * 64 - t * 1.8) +
            3 * Math.cos(u * 119 + t * 2.3)) *
          unit;
        const barHeight = Math.max(height * 0.08, Math.min(height - 2, shape + ripple));
        const totalDots = Math.ceil(barHeight / stepY);
        for (let row = 0; row < totalDots; row++) {
          const y = height - 3 - row * stepY;
          const fromBottom = row / totalDots;
          const flicker = 0.84 + 0.16 * Math.sin(t * 2.4 + x * 0.17 + row * 0.31);
          const alpha = (1 - Math.pow(fromBottom, 0.82) * 0.67) * flicker;
          const hue = 42 - fromBottom * 12;
          const light = 52 + (1 - fromBottom) * 8;
          ctx.fillStyle = "hsla(" + hue + ", 100%, " + light + "%, " + alpha + ")";
          ctx.fillRect(x, y, dotW, dotH);
          if (row < 9 && Math.floor(x / stepX) % 5 === 0) {
            ctx.fillStyle = "rgba(255,222,52," + 0.16 * alpha + ")";
            ctx.fillRect(x - 1, y - 0.5, dotW + 2, dotH + 1);
          }
        }
      }
      if (!reduceMotion) frameId = requestAnimationFrame(draw);
    }

    resize();
    frameId = requestAnimationFrame(draw);

    const ro =
      typeof ResizeObserver === "function"
        ? new ResizeObserver(() => {
            resize();
            if (reduceMotion) draw(0);
          })
        : null;
    if (ro) ro.observe(canvas);

    const onVis = () => {
      if (document.hidden) {
        cancelAnimationFrame(frameId);
      } else if (!reduceMotion) {
        cancelAnimationFrame(frameId);
        frameId = requestAnimationFrame(draw);
      }
    };
    document.addEventListener("visibilitychange", onVis);

    section._saMwSmokeCleanup = () => {
      cancelAnimationFrame(frameId);
      document.removeEventListener("visibilitychange", onVis);
      if (ro) ro.disconnect();
    };
  }

  function initSection(section) {
    if (!section || section.dataset.saMwInit === "1") return;
    section.dataset.saMwInit = "1";
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    initReveal(section, reduceMotion);
    initSmoke(section, reduceMotion);
  }

  function boot(root) {
    const scope = root || document;
    scope.querySelectorAll("[data-sa-mw-section]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot());
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    boot(event.target);
  });
})();
